import { urlForImage } from '@/sanity/lib/image'
import { useMediaQuery } from '@mui/material'
import Image from 'next/image'

const ImageSpacer = ({ image }) => {
  const isMobile = useMediaQuery('(max-width:767px)')
  const base =
    'relative w-full aspect-[9/16] md:aspect-video mt-largeMobile lg:mt-largeDesktop'
    
  return (
    <section className={base}>
      {!isMobile && (
        <Image
          src={urlForImage(image.desktop).url()}
          alt={image.desktop.alt}
          fill
          placeholder="blur"
          blurDataURL={image.desktop.metadata.lqip}
          className="object-cover"
        />
      )}
      {isMobile && (
        <Image
          src={urlForImage(image.mobile).url()}
          alt={image.mobile.alt}
          fill
          placeholder="blur"
          blurDataURL={image.mobile.metadata.lqip}
          className="object-cover"
        />
      )}
    </section>
  )
}

export default ImageSpacer
